import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.testimonialGridComponent.scss';
import textLinkArrow from "../../images/arrow-right-blue-textlink.svg";

const TestimonialGridComponent = ({ data }) => {
    return (
        <div className="cp-testimonialGridComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-testimonialGridComponent__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                <span data-sal="slide-left" data-sal-duration="2000" data-sal-delay="800" data-sal-easing="ease" className="iconOne l--absolute"></span>
                <span data-sal="slide-right" data-sal-duration="2000" data-sal-delay="800" data-sal-easing="ease" className="iconTwo l--absolute"></span>
                <span data-sal="slide-up" data-sal-duration="2000" data-sal-delay="800" data-sal-easing="ease" className="iconThree l--absolute"></span>
                <span data-sal="slide-up" data-sal-duration="2000" data-sal-delay="800" data-sal-easing="ease" className="iconFour l--absolute"></span>
                {data.testimonialsGridSectionHeader &&
                    <h2 data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease">{data.testimonialsGridSectionHeader}</h2>
                }
                {data.testimonialsGridSectionTeaser &&
                    <div data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease" dangerouslySetInnerHTML={{ __html: data.testimonialsGridSectionTeaser }} />
                }
                {data.testimonialsGridSectionRepeaterSections &&
                    <div className="cp-testimonialGridComponent__grid l--flex" data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease">
                        {data.testimonialsGridSectionRepeaterSections.map((testimonial, index) => (
                            <div className="cp-testimonialGridComponent__grid-section l--flex" key={index} style={{ backgroundColor: `${testimonial.backgroundColor}` }}>
                                <div className="cp-testimonialGridComponent__grid-sectionTop">
                                    {testimonial.logo &&
                                        <GatsbyImage image={getImage(testimonial.logo)} alt={testimonial.logo.altText} />
                                    }
                                    {testimonial.header &&
                                        <h3 dangerouslySetInnerHTML={{ __html: testimonial.header }} />
                                    }
                                    {testimonial.link &&
                                        <a href={testimonial.link.url} target={testimonial.link.target} className="l-textlink">
                                            <span>{testimonial.link.title}</span>
                                            <img loading="lazy" src={textLinkArrow} alt="" />
                                        </a>
                                    }
                                </div>
                                <div className="cp-testimonialGridComponent__grid-sectionBottom">
                                    {process.env.GATSBY_LANG === "de" ?
                                        <h5 className="l-results">Ergebnisse</h5>
                                        :
                                        <h5 className="l-results">Results</h5>
                                    }
                                    <div className="l--resultsContent l--flex">
                                        <div>
                                            {testimonial.resultsHeader1 &&
                                                <h4>{testimonial.resultsHeader1}</h4>
                                            }
                                            {testimonial.resultsText1 &&
                                                <p>{testimonial.resultsText1}</p>
                                            }
                                        </div>
                                        <div>
                                            {testimonial.resultsHeader2 &&
                                                <h4>{testimonial.resultsHeader2}</h4>
                                            }
                                            {testimonial.resultsText2 &&
                                                <p>{testimonial.resultsText2}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default TestimonialGridComponent;